// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import DashboardOutlined from '/opt/buildhome/repo/admin_web/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/DashboardOutlined';
import ShopOutlined from '/opt/buildhome/repo/admin_web/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/ShopOutlined';
import NotificationOutlined from '/opt/buildhome/repo/admin_web/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/NotificationOutlined';
import SettingOutlined from '/opt/buildhome/repo/admin_web/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SettingOutlined';
export default { DashboardOutlined, ShopOutlined, NotificationOutlined, SettingOutlined };
